export type permission_detail = {
    read: boolean,
    write: boolean,
    update: boolean,
    delete: boolean,
};

export type permissionCheckStyle = 'all' | 'some';

export class PermissionCheck {
    section: string;
    detail: string;

    constructor(section: string, detail: string) {
        this.section = section;
        this.detail = detail;
    }
};



// WEBPACK FOOTER //
// ./js/utils/types/permission.ts